import React, { useState } from "react";
import PropTypes from "prop-types";

import Form from "shared/components/inputs/form/Form";
import ModalActions from "shared/components/feedback/modals/ModalActions";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";
import { sendNotification } from "shared/components/feedback/notification/notification";
import useTimeOffApi from "../querys/useTimeOff";

const DeleteTimeOffRequestConfirmation = ({
    timeOffRequestIdToDelete,
    onClose,
}) => {
    const { deleteTimeOffRequest } = useTimeOffApi();
    const modifier = deleteTimeOffRequest;
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onSubmit = async () => {
        const data = { timeOffRequestId: timeOffRequestIdToDelete };
        setIsSubmitting(true);
        await modifier.mutateAsync(data)
        sendNotification(<>Time off request has been deleted</>);
        setIsSubmitting(false);
        onClose();

    };
    return (
        <Form onSubmit={onSubmit}>
            <VStack spacing="Three">
                <Text variant="Body_1_1" color="Gray_2">
                    Are you sure you'd like to delete time off?
                </Text>
                <ModalActions
                    primaryAction={{
                        type: "submit",
                        label: "Yes, Delete",
                    }}
                    secondaryAction={{
                        type: "button",
                        label: "Cancel",
                        to: "?action=edit&id=" + timeOffRequestIdToDelete,

                    }}
                    isSubmiting={isSubmitting}
                />
            </VStack>
        </Form>
    );
};

DeleteTimeOffRequestConfirmation.propTypes = {
    timeOffRequestIdToDelete: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired
};

export default DeleteTimeOffRequestConfirmation;
